<template>
  <v-form @submit.prevent="save" novalidate>
    <pr-box :title="titleBox">

      <div slot="buttons-header">
        <v-btn icon @click.native="goToList">
          <v-icon color="white">list</v-icon>
        </v-btn>
      </div>
      <v-layout row wrap>

        <v-flex xs12 md5>
          <v-text-field
            label="Nome da Tabela"
            v-model="resource.table_name"
            :counter="100"
            required
            :error-messages="validationErrors.table_name">
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 md12>
          <v-select
            :items="users"
            v-model="resource.users"
            item-text="name"
            item-value="id"
            clearable
            return-object
            multiple
            chips
            small-chips
            :error-messages="validationErrors.users"
            label="Selecione os usuários">
          </v-select>
        </v-flex>

      </v-layout>

      <div slot="buttons-footer">
        <v-btn flat type="submit" color="primary" :loading="saveLoading">Salvar</v-btn>
      </div>
    </pr-box>
  </v-form>
</template>

<script>
import CrudMixin from '@/components/mixins/CrudMixin';
import TableManagerService from '@/features/table-manager/TableManagerService';
import UserService from '@/features/user/UserService';

export default {
  name: 'table-manager-form',
  mixins: [CrudMixin],
  data() {
    return {
      users: [],
      userService: new UserService(),
    };
  },
  created() {
    this.loadCombos();
  },
  methods: {
    initCrud() {
      this.serviceType = TableManagerService;
      this.routerName = 'table-manager';
      this.componentType = 'FORM';
    },
    beforeSave() {
      if (this.resource.table_name) {
        this.resource.table_name = this.resource.table_name.toLowerCase();
      }
    },
    async loadCombos() {
      this.users = await this.userService.query();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/features/table-manager/TableManagerForm.vue